import { render, staticRenderFns } from "./consult-view.vue?vue&type=template&id=6523c746&scoped=true"
import script from "./consult-view.vue?vue&type=script&lang=ts"
export * from "./consult-view.vue?vue&type=script&lang=ts"
import style0 from "./consult-view.vue?vue&type=style&index=0&id=6523c746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6523c746",
  null
  
)

export default component.exports